export class QuickInvoiceItem {
  constructor() {
    (this.item = ""), (this.description = ""), (this.amount = 0);
  }
}
